import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  // リンククリック時にページのトップにスクロールする関数
  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer">
      <div className="footer-lead">
        <div>
          <p className="footer-eyebrow">THE SOCIAL STANDARD FOR TALENT</p>
          <p className="footer-tagline">その実力に、<span>OSUMITSUKI</span>を。</p>
        </div>
        <Link to="/contact" onClick={handleClick} className="ds-btn ds-btn--primary ds-btn--arrow">
          お問い合わせ
        </Link>
      </div>
      <div className="footer-content">
        <div className="footer-box">
          <h3>会社案内</h3>
          <div className="footer-links">
            <Link to="/company" onClick={handleClick}>
              会社概要
            </Link>
          </div>
        </div>
        <div className="footer-box">
          <h3>サービス</h3>
          <div className="footer-links">
            <Link to="/service" onClick={handleClick}>
              サービス紹介
            </Link>
            <Link to="/service" onClick={handleClick}>
              転職のセンター試験
            </Link>
            <Link to="/service" onClick={handleClick}>
              スキルの通知表
            </Link>
            <a href="https://pack.p-osumitsuki.com/" target="_blank" rel="noopener noreferrer">
              スキルの拡張パック
            </a>
          </div>
        </div>
        <div className="footer-box">
          <h3>導入事例</h3>
          <div className="footer-links">
            <Link to="/case-studies" onClick={handleClick}>
              導入事例一覧
            </Link>
          </div>
        </div>
        <div className="footer-box">
          <h3>採用情報</h3>
          <div className="footer-links">
            <Link to="/recruit" onClick={handleClick}>
              採用情報
            </Link>
          </div>
        </div>
        <div className="footer-box">
          <h3>お役立ち資料</h3>
          <div className="footer-links">
            <Link to="/content" onClick={handleClick}>
              お役立ち資料
            </Link>
          </div>
        </div>
        <div className="footer-box">
          <h3>お問合せ</h3>
          <div className="footer-links">
            <Link to="/contact" onClick={handleClick}>
              お問い合わせフォーム
            </Link>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-legal">
          <Link to="/privacy" onClick={handleClick}>プライバシーポリシー</Link>
        </div>
        <p className="footer-copyright">© PortRay Inc. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
